import { path } from 'ramda';

export const isPreloaderLoadingSelector = path(['preloader']);
export const toastifySelector = path(['toastify']);

